var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1714_29968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76793 7.10077C9.96319 6.90551 9.96319 6.58893 9.76793 6.39367C9.57267 6.19841 9.25608 6.19841 9.06082 6.39367L8.00016 7.45433L6.9395 6.39367C6.74424 6.19841 6.42766 6.19841 6.2324 6.39367C6.03713 6.58893 6.03713 6.90551 6.2324 7.10077L7.29306 8.16144L6.2324 9.2221C6.03713 9.41736 6.03713 9.73394 6.2324 9.9292C6.42766 10.1245 6.74424 10.1245 6.9395 9.9292L8.00016 8.86854L9.06082 9.9292C9.25609 10.1245 9.57267 10.1245 9.76793 9.9292C9.96319 9.73394 9.96319 9.41736 9.76793 9.2221L8.70727 8.16144L9.76793 7.10077Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833008C4.04212 0.833008 0.833496 4.04163 0.833496 7.99967C0.833496 11.9577 4.04212 15.1663 8.00016 15.1663C11.9582 15.1663 15.1668 11.9577 15.1668 7.99967C15.1668 4.04163 11.9582 0.833008 8.00016 0.833008ZM1.8335 7.99967C1.8335 4.59392 4.59441 1.83301 8.00016 1.83301C11.4059 1.83301 14.1668 4.59392 14.1668 7.99967C14.1668 11.4054 11.4059 14.1663 8.00016 14.1663C4.59441 14.1663 1.8335 11.4054 1.8335 7.99967Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1714_29968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/CloseCircle.31f7b47873f91c0ad6d3c5df5145df39.svg";
export { ForwardRef as ReactComponent };